import { createContext } from 'react';
import { AdvancedFiltersContextType } from './types';

export const AdvancedFiltersContext = createContext<AdvancedFiltersContextType>(
  {} as unknown as AdvancedFiltersContextType,
);
